<template>
<div class="mycharts">
    <div v-if="!(sysData.length==0)">
        <div class="total">{{totalNum}}</div>
        <div :id="id" style="width: 100%; height: 270px"></div>
    </div>
    <div class="wrap" v-else>
        <div class="big-circle" >
            <div class="small-circle">
                <div>
                    <p>本期间</p>
                    <p>{{text}}</p>
                </div>
            </div>
        </div>
    </div>
    
</div>
    
</template>

<script>
import echarts from "echarts";

export default {
    name: "",
    props: {
        id: {
            type: String,
            default: "myChart",
        },
        totalNum:{
            type: String,
            default: '0',
        },
        width: {
            type: String,
            default: "100%",
        },
        height: {
            type: String,
            default: "100%",
        },
        nameData: {
            type: Array,
            default: Array,
        },
        sysData: {
            type: Array,
            default: Array,
        },
        text:{
            type: String,
            default: "无数据",
        },
    },
    data() {
        return {
            charts: "",
        };
    },
    created() {
        // this.queryHomeXl();
    },
    watch:{
        sysData(){
            this.$nextTick(function () {
                if(this.sysData.length!==0){
                    this.myEcharts(this.sysData);
                }
            });
        },
    },
    methods: {
        myEcharts(datas) {
            // 基于准备好的dom，初始化echarts实例
            this.charts = echarts.init(document.getElementById(this.id));
            var option = {
                color:['#5AAEF3','#FF974C','#62D9AD','#bf74ea','#efcd12','#1CE0DA','#FF99C3','#654CFF','#F35A7F','#CFE86D'],
                series: [
                    {
                        type: "pie",
                        radius: [60, 80],
                        left: "center",
                        width:200,
                        minAngle: 30,//最小角度
                        startAngle:270, //起始角度
                        itemStyle: {
                            borderColor: "#fff",
                            borderWidth: 2,
                        },
                        label: {
                            // alignTo: 'edge',
                            // position :'outside',
                            formatter: '{name|{b}}{value|（{c}个）}',
                            // minMargin:0,
                            // edgeDistance: 0,
                            // lineHeight: 20,
                            rich: {
                                value: {
                                    fontSize: 12,
                                    color: '#999'
                                }
                            }
                        },
                        labelLine: {
                            length: 20,
                            length2:20,
                            maxSurfaceAngle: 80,
                        },
                        labelLayout: function (params) {
                            console.log(params)
                            var isLeft = params.labelRect.x < echarts.getWidth() / 2;
                            var points = params.labelLinePoints;
                            // Update the end point.
                            points[2][0] = isLeft
                                ? params.labelRect.x
                                : params.labelRect.x + params.labelRect.width;

                            return {
                                labelLinePoints: points
                            };
                        },
                        data: datas,
                    }
                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            this.charts.setOption(option);
        },
        // queryHomeXl() {
        //     this.$nextTick(function () {
        //         console.log(this.sysData);
        //         this.myEcharts(this.sysData);
        //     });
        // },
    },
    //调用
    mounted() {
        
    },
};
</script>

<style scoped>
.mycharts{
    position: relative;
}
.total{
    width:125px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 9;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    margin:auto;
}
.wrap{
    width:100%;
    height: 200px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.big-circle{
    width:160px;
    height: 160px;
    background:#D0D0D0;
    border-radius: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.small-circle{
    width:120px;
    height: 120px;
    background:#fff;
    border-radius: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #D0D0D0;
}
.small-circle p{
    padding: 3px 0;
}
</style>
